import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
    ClassicEditor, Bold, Essentials, Italic, Mention, Paragraph, Undo, Heading, FontFamily, FontSize,
    FontColor, FontBackgroundColor, Strikethrough, Subscript, Superscript, Code,
    Link, CodeBlock, TodoList, Indent,
    Alignment
} from 'ckeditor5';
import PN from "persian-number";
import 'ckeditor5/ckeditor5.css';
import { Modal } from "react-bootstrap";
import Delete from '../Delete/Delete.js';
import Drp_Brand from '../ProductBrand/Drp_Brand.js';
import Drp_Group from '../ProductGroup/Drp_Group.js';
import Drp_ParentGroup from '../ProductGroup/Drp_Group.js';
import Drp_BrandSearch from '../ProductBrand/Drp_Brand.js';
import Drp_GroupSearch from '../ProductGroup/Drp_Group.js';
import Drp_ParentGroupSearch from '../ProductGroup/Drp_Group.js';
import Auto_Unit from '../Product/Auto_Unit.js';
import Drp_Store from '../StoreRoom/Drp_StoreRoom_Simple.js'
import Drp_StoreRoom_Simple from '../StoreRoom/Drp_StoreRoom_Simple.js';


const ProductIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const BrandRef = useRef();
    const GroupRef = useRef();
    const ParentGroupRef = useRef();
    const SearchBrandRef = useRef();
    const SearchGroupRef = useRef();
    const SearchParentGroupRef = useRef();
    const UnitRef = useRef();
    const DeleteRef = useRef();

    const [PropertyList, setPropertyList] = useState([]);
    const [PropertyPermission, setPropertyPermission] = React.useState(false);
    const [ShowPropertyModal, setShowPropertyModal] = React.useState(false);

    const [ProductList, setProductList] = useState([]);
    const [Id, setId] = useState(General.GuidEmpty());
    const [Title, setTitle] = useState('');
    const [Comment, setComment] = useState('');
    const [MetaDescription, setMetaDescription] = useState('');
    const [LastPrice, setLastPrice] = useState(0);
    const [LastPriceCoworker, setLastPriceCoworker] = useState(0);
    const [LastBuyPrice, setLastBuyPrice] = useState(0);
    const [PhotoTag, setPhotoTag] = useState('');
    const [IdentityNo, setIdentityNo] = useState('');
    const [GroupId, setGroupId] = useState(-1);
    const [Unit, setUnit] = useState("");
    const [ParentGroupId, setParentGroupId] = useState(-1);
    const [BrandId, setBrandId] = useState(-1);
    const [SaleType, setSaleType] = useState(-1);
    const [IsActive, setIsActive] = useState(true);
    const [WebIsActive, setWebIsActive] = useState(true);
    const [HasCatalog, setHasCatalog] = useState(false);
    const [Catalog, setCatalog] = useState([]);

    const [SearchTitle, setSearchTitle] = useState('');
    const [SearchGroupId, setSearchGroupId] = useState(-1);
    const [SearchParentGroupId, setSearchParentGroupId] = useState(-1);
    const [SearchBrandId, setSearchBrantId] = useState(-1);
    const [SearchIsActive, setSearchIsActive] = useState(1);
    const [SearchWebIsActive, setSearchWebIsActive] = useState(1);

    const [PhotoPermission, setPhotoPermission] = React.useState(false);
    const [ShowPhotoModal, setShowPhotoModal] = React.useState(false);
    const [PhotoList, setPhotoList] = useState([]);
    const [PhotoURLName, setPhotoURLName] = useState("");
    const [IsMain, setIsMain] = useState(false);
    const [Order, setOrder] = useState(1);
    const [ProductType, setProductType] = useState(0);
    const [Current, setCurrent] = useState(0);
    const [Power, setPower] = useState(0);
    const [Image, setImage] = useState({ preview: "", raw: "" });
    const [OnlineStoreId, setOnlineStoreId] = React.useState(-1);
    const [Garranty, setGarranty] = React.useState(0);

    const [ShowModal, setShowModal] = React.useState(false);
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)
    const CompactCell = props => <rsuite.Table.Cell {...props} style={{ padding: 4 }} />;
    const CompactHeaderCell = props => <rsuite.Table.HeaderCell {...props} style={{ padding: 4 }} />;


    const defaultColumns = [

        {
            key: 'IdentityNo',
            label: 'شناسه محصول',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1
        },
        {
            key: 'ParentTitle',
            label: ' گروه ',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1
        },
        {
            key: 'GroupTitle',
            label: ' زیر گروه ',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 2
        },

        {
            key: 'BrandTitle',
            label: 'برند ',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1
        },
        {
            key: 'SaleTypeComment',
            label: 'نوع فروش در وب',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 2
        },

        {
            key: 'OnlineStore',
            label: 'انبار فروش در وب',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 2
        },
        {
            key: 'Garranty',
            label: 'گارانتی (ماه)',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 2
        }
        ,
        {
            key: 'LastPrice',
            label: ' قیمت',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 2
        },
        {
            key: 'PhotoCount',
            label: 'تصاویر',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1
        },
        {
            key: 'IsActive',
            label: 'فعال',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1
        },
        {
            key: 'WebIsActive',
            label: 'فعال در وب',
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1
        }

    ];

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };
    const handleChangeLimit = dataKey => {
        setPage(1);
        setLimit(dataKey);
    };


    const [compact, setCompact] = React.useState(true);
    const [columnKeys, setColumnKeys] = React.useState(defaultColumns.map(column => column.key));

    const columns = defaultColumns.filter(column => columnKeys.some(key => key === column.key));
    const CustomCell = compact ? CompactCell : rsuite.Table.Cell;
    const CustomHeaderCell = compact ? CompactHeaderCell : rsuite.Table.HeaderCell;
    const [limit, setLimit] = React.useState(10);
    const [page, setPage] = React.useState(1);

    //#endregion

    const Parent_Change = (value, Title, Type) => {
        setParentGroupId(value);
        setProductType(Type);
        GroupRef.current.BindGroupByParentId(0, value)
    }


    const SearchParent_Change = (value) => {
        setSearchParentGroupId(value);
        SearchGroupRef.current.BindGroupByParentId(0, value)
    }
    const Unit_Change = (value) => {
        setUnit(value);
        UnitRef.current.Bind(value)
    }

    const CatalogChange = e => {
        if (e.target.files.length) {
            setCatalog(e.target.files[0]);
        }
    };


    //#region Methods

    const Search = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/Product/Search', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'BrandId': SearchBrandId,
                    'ProductGroupId': SearchGroupId,
                    'ProductGroupParentId': SearchParentGroupId,
                    'Title': SearchTitle,
                    'WebIsActive': SearchWebIsActive,
                    'IsActive': SearchIsActive
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    console.dir(result)
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            Row: i + 1,
                            Id: result[i].id,
                            LastPrice: PN.sliceNumber(result[i].lastPrice),
                            LastPriceCoworker: PN.sliceNumber(result[i].lastPriceCoworker),
                            WebIsActive: result[i].webIsActive,
                            IsActive: result[i].isActive,
                            Title: result[i].title,
                            ParentTitle: result[i].parentTitle,
                            GroupTitle: result[i].groupTitle,
                            BrandTitle: result[i].brandTitle,
                            IdentityNo: result[i].identityNo,
                            PhotoTag: result[i].photoTag,
                            HasCatalog: result[i].hasCatalog,
                            PhotoCount: result[i].photoCount,
                            SaleType: result[i].saleType,
                            Power: result[i].power,
                            Current: result[i].current,
                            Garranty: result[i].garranty,
                            OnlineStoreId: result[i].onlineStoreId,
                            OnlineStore: result[i].store,
                            Unit: result[i].unit,
                            SaleTypeComment: result[i].saleType == 1 ? "قابل فروش" : result[i].saleType == 2 ? "قابل رزرو" : result[i].saleType == 3 ? "غیر قابل فروش" : "",

                        })
                    }
                    console.dir(tmp)
                    setProductList(tmp)
                })
        )
    }


    const Reset = () => {
        setPhotoList([]);
        setId(General.GuidEmpty());
        setTitle('');
        setComment('');
        setMetaDescription('');
        setPhotoTag('');
        setIdentityNo('');
        setIsActive(true);
        setWebIsActive(true);
        setHasCatalog(false);
        setPower(0);
        setCurrent(0);
        setLastPrice(0);
        setLastPriceCoworker(0);
        setLastBuyPrice(0)
        setUnit("")
        setCatalog([]);
        setPhotoList([]);
        setImage({ preview: "", raw: "" })
        setPhotoTag("");
        setOrder(1);
        setIsMain(0);
        setSaleType(-1)
    }

    const Save = () => {
        if (Title == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("عنوان اجباری می باشد")), 'topCenter')
            return;
        }
        // if (LastPrice == "" || LastPriceCoworker == ""
        // // ) {
        //     console.dir(LastPrice)
        //     console.dir(LastPriceCoworker)
        //     console.dir(LastBuyPrice)

        //     toaster.push(General.ShowMessage('error', General.ErrorMessage("قیمت محصول اجباری می باشد")), 'topCenter')
        //     return;
        // }

        if (Unit == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("واحد نگهداری در انبار اجباری می باشد")), 'topCenter')
            return;
        }

        if (PhotoTag == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("ّبرچسب تصاویر اجباری می باشد")), 'topCenter')
            return;
        }
        if (BrandId == "-1") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" برند اجباری می باشد")), 'topCenter')
            return;
        }
        if (GroupId == -1) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" گروه محصول اجباری می باشد")), 'topCenter')
            return;
        }
        if (SaleType == -1) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" نوع فروش محصول اجباری می باشد")), 'topCenter')
            return;
        }
        if (ProductType == 1 && Current == 0) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" جریان محصول اجباری می باشد")), 'topCenter')
            return;
        }
        if (ProductType == 1 && Power == 0) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" توان محصول اجباری می باشد")), 'topCenter')
            return;
        }
        if (HasCatalog == 1 && Id == General.GuidEmpty() && (Catalog == null || Catalog == "")) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" فایل کاتالوگ اجباری می باشد")), 'topCenter')
            return;
        }
        var f_data = new FormData();
        f_data.append("Id", Id);
        f_data.append("Title", Title);
        f_data.append("Current", Current);
        f_data.append("Power", Power);
        f_data.append("Comment", Comment);
        f_data.append("MetaDescription", MetaDescription);
        f_data.append("PhotoTag", PhotoTag);
        f_data.append("BrandId", BrandId);
        f_data.append("ProductGroupId", GroupId);
        f_data.append("LastPrice", LastPrice);
        f_data.append("LastPriceCoworker", LastPriceCoworker);
        f_data.append("HasCatalog", HasCatalog ? 1 : 0);
        f_data.append("IsActive", IsActive ? 1 : 0);
        f_data.append("WebIsActive", WebIsActive ? 1 : 0);
        f_data.append("Catalog", Catalog);
        f_data.append("SaleType", SaleType);
        f_data.append("Unit", Unit);
        f_data.append("Garranty", Garranty);
        f_data.append("OnlineStoreId", OnlineStoreId);
        var RequestOptions = {
            method: "post",
            withCredentials: true,
            headers: {
                'ApiKey': General.APIKey(),
                'content-type': 'multipart/form-data'
            }

        }

        trackPromise(
            axios.post(General.ApiRoute() + "/Product/Save", f_data, RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        if (LastPrice * 1 < LastBuyPrice * 1 || LastPriceCoworker < LastBuyPrice) {
                            toaster.push(General.ShowMessage('error', General.SuccessMessage("قیمت فروش  کمتر از آخرین قیمت خرید (" + LastBuyPrice + ") ثبت شد")), 'topCenter')
                        }
                        else {
                            toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')

                        }
                        Search();
                        Reset();
                        if (Id != General.GuidEmpty())
                            setShowModal(false);
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const ShowDelete = (id, fullName) => {
        DeleteRef.current.Get(6, id, fullName);
    }

    const ShowEdit = (Id) => {
        Reset();
        setGroupId(-1);
        setParentGroupId(-1);
        setBrandId(-1);
        setId(Id);
        setShowModal(true);
        trackPromise(
            fetch(General.ApiRoute() + '/Product/GetById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': Id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {



                    setId(Id);
                    setTitle(result.title);
                    setPhotoTag(result.photoTag);
                    setIdentityNo(result.identityNo);
                    setGroupId(result.productGroupId);
                    setParentGroupId(result.productGroupParentId);
                    setBrandId(result.brandId);
                    setPower(result.power);
                    setCurrent(result.current);
                    setProductType(result.productType)
                    setLastPrice(result.lastPrice);
                    setLastPriceCoworker(result.lastPriceCoworker);
                    setLastBuyPrice(result.lastBuyPrice);
                    setUnit(result.unit);
                    setHasCatalog(result.hasCatalog == 0 ? false : true);
                    setIsActive(result.isActive == 0 ? false : true);
                    setWebIsActive(result.webIsActive == 0 ? false : true);
                    setSaleType(result.saleType);
                    setComment(result.comment);
                    setMetaDescription(result.metaDescription);
                    setGarranty(result.garranty);
                    setOnlineStoreId(result.onlineStoreId);

                    BrandRef.current.BindBrand(result.brandId);
                    ParentGroupRef.current.BindGroupByParentId(result.productGroupParentId, 0);
                    setTimeout(() => {
                        GroupRef.current.BindGroupByParentId(result.productGroupId, result.productGroupParentId);
                        // setGroupId(result.productGroupId);

                    }, 2000);



                })
        )
    }

    const ShowNew = () => {
        setShowModal(true);
        Reset();
        setGroupId(-1);
        setParentGroupId(-1);
        setBrandId(-1);
        setTimeout(() => {
            BrandRef.current.BindBrand(-1);
            ParentGroupRef.current.BindGroupByParentId(-1, 0);
            UnitRef.current.Bind();

        }, 1000);

    }

    const ShowProperty = (id, title) => {
        setTitle(title)
        setShowPropertyModal(true);
        setId(id);
        SearchProperty(id);
    }

    const SearchProperty = (productId) => {
        setPropertyList([]);
        trackPromise(
            fetch(General.ApiRoute() + '/ProductProperty/GetByProductIdForInsert', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'ProductId': productId,
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    console.dir(result);

                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            row: i + 1,
                            Id: result[i].id,
                            Title: result[i].title,
                            Comment: result[i].comment,
                            ProductId: result[i].productId,
                            PGPropertyId: result[i].pGpropertyId,
                            Order: result[i].order,
                            status: result[i].comment == "" || result[i].comment == null ? "EDIT" : null,

                        })
                    }
                    setPropertyList(tmp)
                })
        )
    }

    const onEditProperty = (row) => {
        var temp = [...PropertyList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {
            temp[index].status = "EDIT";
        }
        setPropertyList(temp);
    }

    const onChangeProperty = (row, value) => {
        var temp = [...PropertyList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1)
            temp[index].Comment = value;
        setPropertyList(temp);
    }

    const SaveProperty = (id, title, productId, comment, pGPropertyId) => {


        if (comment == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("توضیحات اجباری می باشد")), 'topCenter')
            return;
        }
        var RequestOptions = {
            data: {
                "Id": id,
                "Title": title,
                "ProductId": productId,
                "PGPropertyId": pGPropertyId,
                "Comment": comment
            },
            url: General.ApiRoute() + "/ProductProperty/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                        SearchProperty(productId);
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const DeleteProperty = (id, title, comment, productId) => {

        var RequestOptions = {
            data: {
                "Id": id,
                "Title": title,
                "Comment": comment,
                "ProductId": productId
            },
            url: General.ApiRoute() + "/ProductProperty/Delete",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حذف شده است")), 'topCenter')
                        SearchProperty(productId);
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )




    }

    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 6);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        SearchBrandRef.current.BindBrand(-1);
                        SearchParentGroupRef.current.BindGroupByParentId(-1, 0);
                        CheckPhotoPermission();
                        CheckPropertyPermission();
                        Search();

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    const CheckPropertyPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 8);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        setPropertyPermission(false);
                    }
                    else {
                        setPropertyPermission(true);

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const CheckPhotoPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 9);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        setPhotoPermission(false);
                    }
                    else {
                        setPhotoPermission(true);

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    const ShowPhoto = (id, title, photoTag) => {
        setId(id);
        setTitle(title);
        setPhotoList([]);
        setShowPhotoModal(true);
        setImage({ preview: "", raw: "" })
        setPhotoURLName(photoTag);
        setOrder(1);
        setIsMain(0);
        GetPhoto(id);
    }
    const ImageChange = e => {
        if (e.target.files.length) {
            setImage({
                preview: URL.createObjectURL(e.target.files[0]),
                raw: e.target.files[0]
            });
        }
    };

    const GetPhoto = (id) => {
        trackPromise(
            fetch(General.ApiRoute() + '/ProductPhoto/GetByProductId', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'ProductId': id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            Row: i + 1,
                            Id: result[i].id,
                            PhotoURLName: result[i].photoURLName,
                            IsMain: result[i].isMain,
                            Order: result[i].order,
                            Image: General.ApiPhotoRoute() + 'Content/Images/Product/Photo/' + result[i].photoURLName,

                        })
                    }
                    setPhotoList(tmp)
                })
        )
    }

    const SavePhoto = () => {
        if (PhotoURLName == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("عنوان تصویر اجباری می باشد")), 'topCenter')
            return;
        }
        var f_data = new FormData();
        f_data.append("PhotoTag", PhotoURLName);
        f_data.append("Order", Order);
        f_data.append("ProductTitle", Title);
        f_data.append("IsMain", IsMain ? 1 : 0);
        f_data.append("Image", Image.raw);
        f_data.append("ProductId", Id);
        var RequestOptions = {
            method: "post",
            withCredentials: true,
            headers: {
                'ApiKey': General.APIKey(),
                'content-type': 'multipart/form-data'
            }

        }

        trackPromise(
            axios.post(General.ApiRoute() + "/ProductPhoto/Save", f_data, RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                        GetPhoto(Id);
                        setImage({ preview: "", raw: "" })
                        setOrder(1);
                        setIsMain(0);
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }
    const DeletePhoto = (photoId) => {

        var RequestOptions = {
            data: {
                "Id": photoId,
                "ProductTitle": Title
            },
            url: General.ApiRoute() + "/ProductPhoto/Delete",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("حذف شده است")), 'topCenter')
                        GetPhoto(photoId);
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )




    }


    useEffect(() => {
        CheckPermission();
        document.title = "تعریف محصولات ";
    }, [])
    //#endregion







    return (

        <Layout title="تعریف محصولات ">


            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white h-10 ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Search}>  جستجو</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={ShowNew}>  جـــدید</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label>عتوان   </label>
                            <rsuite.Input value={SearchTitle} onChange={(e) => setSearchTitle(e)} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label>گروه   </label>
                            <Drp_ParentGroupSearch className="rs-input" value={SearchParentGroupId} onChange={SearchParent_Change} ref={SearchParentGroupRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label>زیر گروه   </label>
                            <Drp_GroupSearch className="rs-input" value={SearchGroupId} onChange={(value) => setSearchGroupId(value)} ref={SearchGroupRef} />
                        </rsuite.Col>

                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label> برند   </label>
                            <Drp_BrandSearch className="rs-input" value={SearchBrandId} onChange={(value) => setSearchBrantId(value)} ref={SearchBrandRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label> وضعیت فعال بودن   </label>
                            <select className="rs-input" onChange={(e) => setSearchIsActive(e.target.value)} value={SearchIsActive}>
                                <option value="-1">انتخاب نمایید</option>
                                <option value="0">غیر فعال </option>
                                <option value="1">فعال </option>


                            </select>
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12}>
                            <label> وضعیت فعال بودن در وب سایت   </label>
                            <select className="rs-input" onChange={(e) => setSearchWebIsActive(e.target.value)} value={SearchWebIsActive}>
                                <option value="-1">انتخاب نمایید</option>
                                <option value="0">غیر فعال </option>
                                <option value="1">فعال </option>


                            </select>
                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <label> فیلتر   </label>
                            <rsuite.VStack spacing={16}>

                                <rsuite.TagPicker
                                    data={defaultColumns}
                                    labelKey="label"
                                    valueKey="key"
                                    value={columnKeys}
                                    onChange={setColumnKeys}
                                    cleanable={false}
                                    className='Font10 w-100p'
                                />
                            </rsuite.VStack>
                        </rsuite.Col>


                    </rsuite.Row>

                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table

                                    height={520}
                                    headerHeight={50}
                                    loading={loading}
                                    data={ProductList.sort((a, b) => {
                                        let x = a[sortColumn];
                                        let y = b[sortColumn];
                                        if (typeof x === 'string') {
                                            x = x.charCodeAt();
                                        }
                                        if (typeof y === 'string') {
                                            y = y.charCodeAt();
                                        }
                                        if (sortType === 'asc') {
                                            return x - y;
                                        } else {
                                            return y - x;
                                        }
                                    }).filter((v, i) => {
                                        const start = limit * (page - 1);
                                        const end = start + limit;
                                        return i >= start && i < end;
                                    })}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}
                                    wordWrap="break-word"



                                >

                                    <rsuite.Table.Column fullText flexGrow={1} align="center" sortable>
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Row" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column flexGrow={4} fixed sortable resizable>
                                        <rsuite.Table.HeaderCell>عنوان</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey='Title'>
                                            {(rowData) => {
                                                return <>
                                                    {rowData.Title}
                                                    <small>
                                                        <br />
                                                        (واحد نگهداری در انبار :  {rowData.Unit})

                                                    </small>
                                                    {rowData.Current != 0 && rowData.Power != 0 ?
                                                        <small>
                                                            <br />
                                                            (جریان :  {rowData.Current} A  - توان :   {rowData.Power} KW)
                                                        </small>
                                                        : rowData.Power != 0 ?
                                                            <small>
                                                                <br />
                                                                ( توان :   {rowData.Power} KW)
                                                            </small>
                                                            : rowData.Current != 0 ?
                                                                <small>
                                                                    <br />
                                                                    (جریان :  {rowData.Current} A )
                                                                </small>
                                                                :
                                                                ""
                                                    }
                                                </>


                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>

                                    {columns.map(column => {
                                        const { key, label, ...rest } = column;
                                        return (
                                            <rsuite.Table.Column {...rest} key={key}>
                                                <CustomHeaderCell>{label}</CustomHeaderCell>
                                                <CustomCell dataKey={key}>
                                                    {(rowData) => {
                                                        return <>

                                                            {(key == "IsActive" && rowData.IsActive == 1)
                                                                ||
                                                                (key == "WebIsActive" && rowData.WebIsActive == 1) ?

                                                                <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                                : (key == "IsActive" && rowData.IsActive == 0)
                                                                    ||
                                                                    (key == "WebIsActive" && rowData.WebIsActive == 0) ?
                                                                    <BiIcon.BiXCircle className="text-danger fs-6" />
                                                                    : key == "IdentityNo" ? rowData.IdentityNo
                                                                        : key == "ParentTitle" ? rowData.ParentTitle
                                                                            : key == "GroupTitle" ? rowData.GroupTitle
                                                                                : key == "BrandTitle" ? rowData.BrandTitle
                                                                                    : key == "SaleTypeComment" ? rowData.SaleTypeComment
                                                                                        : key == "LastPrice" ? rowData.LastPrice
                                                                                            : key == "PhotoCount" ? rowData.PhotoCount
                                                                                                : key == "OnlineStore" ? rowData.OnlineStore
                                                                                                    : key == "Garranty" ? rowData.Garranty
                                                                                                        : <></>



                                                            }
                                                        </>


                                                    }}
                                                </CustomCell>
                                            </rsuite.Table.Column>
                                        );
                                    })}





                                    <rsuite.Table.Column flexGrow={1} fixed="right" className='float-start'>
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                        <rsuite.Popover full className='PopoverMenu'>
                                                            <rsuite.Dropdown.Menu  >
                                                                <rsuite.Dropdown.Item onClick={() => ShowEdit(rowData.Id)}>ویرایش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item onClick={() => ShowDelete(rowData.Id, rowData.Title)}>حذف</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={PropertyPermission ? '' : "hide"} onClick={() => ShowProperty(rowData.Id, rowData.Title)}>تعریف مشخصات</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={PhotoPermission ? '' : "hide"} onClick={() => ShowPhoto(rowData.Id, rowData.Title, rowData.PhotoTag)}>تصاویر  </rsuite.Dropdown.Item>
                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                </rsuite.Table>
                                <div style={{ paddingTop: 20 }}>
                                    <rsuite.Pagination
                                        prev
                                        next
                                        first
                                        last
                                        ellipsis
                                        boundaryLinks
                                        maxButtons={5}
                                        size="xs"
                                        layout={['total', '-', 'limit', '|', 'pager', 'skip']}
                                        total={ProductList.length}
                                        limitOptions={[5, 10, 30, 50, 100]}
                                        limit={limit}
                                        activePage={page}
                                        onChangePage={setPage}
                                        onChangeLimit={handleChangeLimit}
                                    />
                                </div>
                            </rsuite.Panel>

                        </div>
                    </div>

                </rsuite.Panel >
            </div >



            <rsuite.Modal size="xl" open={ShowModal} onClose={() => setShowModal(false)} scrollable backdrop="static" keyboard={false}>
                <rsuite.Modal.Header>
                    <rsuite.Modal.Title><b>تعریف محصول </b></rsuite.Modal.Title>
                </rsuite.Modal.Header>
                <rsuite.Modal.Body>
                    <rsuite.Grid fluid>
                        <rsuite.Row className='p-1'>
                            <rsuite.Col xxl={24} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <rsuite.Checkbox onChange={(e, checked) => setIsActive(checked)} checked={IsActive} value={IsActive} /> &nbsp; فعال می باشد
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <rsuite.Checkbox onChange={(e, checked) => setWebIsActive(checked)} checked={WebIsActive} value={WebIsActive} /> &nbsp; در وب سایت فعال می باشد
                            </rsuite.Col>
                        </rsuite.Row>
                        <hr />
                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Title == "" ? 'text-danger' : 'hide'} />  <label>عنوان</label>
                                <rsuite.Input value={Title} onChange={(e) => setTitle(e)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={PhotoTag == "" ? 'text-danger' : 'hide'} />  <label>عنوان معرفی تصویر/کاتالوگ</label>
                                <rsuite.Input value={PhotoTag} onChange={(e) => setPhotoTag(e)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={BrandId == -1 ? 'text-danger' : 'hide'} />
                                <label> برند   </label>
                                <Drp_Brand className="rs-input" value={BrandId} onChange={(value) => setBrandId(value)} ref={BrandRef} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={ParentGroupId == -1 ? 'text-danger' : 'hide'} />
                                <label>گروه   </label>
                                <Drp_ParentGroup className="rs-input" value={ParentGroupId} onChange={Parent_Change} ref={ParentGroupRef} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={GroupId == -1 ? 'text-danger' : 'hide'} />
                                <label>زیر گروه   </label>
                                <Drp_Group className="rs-input" value={GroupId} onChange={(value) => setGroupId(value)} ref={GroupRef} />
                            </rsuite.Col>
                            <rsuite.Col className={ProductType == 1 || ProductType == 2 ? '' : 'hide'} xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={Power == 0 ? 'text-danger' : 'hide'} />  <label>توان (KW)</label>
                                <rsuite.InputNumber step={0.001} min={0} max={100} value={Power} onChange={(e) => setPower(e)} />
                            </rsuite.Col>
                            <rsuite.Col className={ProductType == 1 ? '' : 'hide'} xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={Current == 0 ? 'text-danger' : 'hide'} />  <label>جریان (A)</label>
                                <rsuite.InputNumber step={0.001} min={0} max={10000} value={Current} onChange={(e) => setCurrent(e)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={GroupId == -1 ? 'text-danger' : 'hide'} />
                                <label> واحد نگهداری در انبار   </label>
                                <Auto_Unit className="rs-input" value={Unit} onChange={(value) => Unit_Change(value)} ref={UnitRef} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={GroupId == -1 ? 'text-danger' : 'hide'} />
                                <label> گارانتی (ماه)   </label>
                                <rsuite.InputNumber value={Garranty} onChange={(value) => setGarranty(value)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={SaleType == -1 ? 'text-danger' : 'hide'} />
                                <label> نوع فروش در وب سایت   </label>
                                <select className="rs-input" onChange={(e) => setSaleType(e.target.value)} value={SaleType}>
                                    <option value="-1">انتخاب نمایید</option>
                                    <option value="1">قابل فروش </option>
                                    <option value="2">قابل رزرو </option>
                                    <option value="3">غیر قابل فروش </option>
                                </select>
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={GroupId == -1 ? 'text-danger' : 'hide'} />
                                <label> انبار فروش آنلاین  </label>
                                <Drp_StoreRoom_Simple className="rs-input" value={OnlineStoreId} onChange={(value) => setOnlineStoreId(value)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={LastPrice == "" ? 'text-danger' : 'hide'} />  <label>قیمت</label>
                                <rsuite.Input value={PN.sliceNumber(LastPrice)} onChange={(e) => setLastPrice(e.replaceAll(',', '') * 1)} />
                                <rsuite.Text className='Font10 float-start' as='sub'>{LastPrice != "0" ? <>{PN.convert(LastPrice)} ریال</> : ""}</rsuite.Text>

                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <BiIcon.BiSolidStar className={LastPriceCoworker == "" ? 'text-danger' : 'hide'} />  <label>قیمت همکار</label>
                                <rsuite.Input value={PN.sliceNumber(LastPriceCoworker)} onChange={(e) => setLastPriceCoworker(e.replaceAll(',', '') * 1)} />
                                <rsuite.Text className='Font10 float-start' as='sub'>{LastPriceCoworker != "0" ? <>{PN.convert(LastPriceCoworker)} ریال</> : ""}</rsuite.Text>
                            </rsuite.Col>


                        </rsuite.Row>
                        <rsuite.Row>

                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <rsuite.Checkbox onChange={(e, checked) => setHasCatalog(checked)} checked={HasCatalog} value={HasCatalog} /> &nbsp; دارای کاتالوگ می باشد

                            </rsuite.Col>
                            <rsuite.Col className={HasCatalog == true ? '' : 'hide'} xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <input type="file" label="انتخاب فایل" onChange={CatalogChange} className='rs-input' id="poster" name="poster" accept=".pdf" />
                            </rsuite.Col>
                        </rsuite.Row>
                        <rsuite.Row>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <label> توضیحات محصول   </label>

                                <CKEditor
                                    editor={ClassicEditor} data={Comment} onChange={(e, editor) => (setComment(editor.getData()), console.dir(editor.getData()), console.dir(e))}
                                    config={{
                                        toolbar: {
                                            items: ['undo', 'redo',
                                                '|', 'heading',
                                                '|', 'alignment', 'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor',
                                                '|', 'bold', 'italic', 'strikethrough', 'subscript', 'superscript', 'code',
                                                '|', 'link',
                                                '|', 'todoList', 'indent'],
                                        },
                                        plugins: [
                                            Bold, Essentials, Italic, Mention, Paragraph,
                                            Undo, Heading, FontFamily, FontSize, Alignment,
                                            FontColor, FontBackgroundColor, Strikethrough,
                                            Subscript, Superscript, Code,
                                            Link, CodeBlock, TodoList, Indent
                                        ],

                                        licenseKey: '<YOUR_LICENSE_KEY>',
                                        language: {
                                            content: 'ar'
                                        },

                                        mention: {
                                            // Mention configuration
                                        },
                                        initialData: Comment,


                                    }}
                                />
                            </rsuite.Col>
                        </rsuite.Row>
                        <rsuite.Row>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <label> توضیحات محصول برای Seo حداقل 150 و حداکثر 200 کاراکتر   </label>

                                <CKEditor
                                    editor={ClassicEditor} data={MetaDescription} onChange={(e, editor) => (setMetaDescription(editor.getData()), console.dir(editor.getData()), console.dir(e))}
                                    config={{
                                        toolbar: {
                                            items: ['undo', 'redo',
                                                '|', 'heading',
                                                '|', 'alignment', 'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor',
                                                '|', 'bold', 'italic', 'strikethrough', 'subscript', 'superscript', 'code',
                                                '|', 'link',
                                                '|', 'todoList', 'indent'],
                                        },
                                        plugins: [
                                            Bold, Essentials, Italic, Mention, Paragraph,
                                            Undo, Heading, FontFamily, FontSize, Alignment,
                                            FontColor, FontBackgroundColor, Strikethrough,
                                            Subscript, Superscript, Code,
                                            Link, CodeBlock, TodoList, Indent
                                        ],

                                        licenseKey: '<YOUR_LICENSE_KEY>',
                                        language: {
                                            content: 'ar'
                                        },

                                        mention: {
                                            // Mention configuration
                                        },
                                        initialData: MetaDescription,


                                    }}
                                />
                            </rsuite.Col>
                        </rsuite.Row>

                    </rsuite.Grid>
                </rsuite.Modal.Body>
                <rsuite.Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={Save}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setShowModal(false)}>
                        بستن
                    </rsuite.Button>
                </rsuite.Modal.Footer>
            </rsuite.Modal>


            <Modal show={ShowPropertyModal} onHide={() => setShowPropertyModal(false)} size="xl" scrollable backdrop="static" keyboard={false}>
                <Modal.Header >

                    <Modal.Title className='fs-5'><b> {Title}</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <rsuite.Grid fluid>
                        <rsuite.Row className="p-1">

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>


                                <rsuite.Table height={420} data={PropertyList}>
                                    <rsuite.Table.Column className="w-10p" align="center"  >
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="row">
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={1} width={200} fullText resizable>
                                        <rsuite.Table.HeaderCell>عنوان</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey='Title' ></rsuite.Table.Cell>
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column flexGrow={1} fullText >
                                        <rsuite.Table.HeaderCell>توضیحات</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell  >
                                            {(rowData) => {
                                                return <>

                                                    {rowData.status == 'EDIT' ? (
                                                        <rsuite.Input
                                                            defaultValue={rowData.Comment}
                                                            onChange={value => {
                                                                onChangeProperty?.(rowData.row, value);
                                                            }}
                                                        />
                                                    ) : (
                                                        rowData.Comment
                                                    )}
                                                </>
                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>



                                    <rsuite.Table.Column width={100} fixed='right'>
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>

                                                    <BiIcon.BiEditAlt onClick={() => onEditProperty(rowData.row)} className={rowData.status != "EDIT" ? 'fs-6 Cursor' : 'hide'} />
                                                    &nbsp;&nbsp;&nbsp;
                                                    <BiIcon.BiTrash onClick={() => DeleteProperty(rowData.Id, rowData.Title, rowData.Comment, rowData.ProductId)} className={rowData.status != "EDIT" ? 'fs-6 text-danger Cursor' : "hide"} />

                                                    <BiIcon.BiSave onClick={() => SaveProperty(rowData.Id, rowData.Title, rowData.ProductId, rowData.Comment, rowData.PGPropertyId)} className={rowData.status != "EDIT" ? "hide" : 'fs-6 text-success Cursor'} />


                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                </rsuite.Table>



                            </rsuite.Col>



                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="subtle" onClick={() => setShowPropertyModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>


            <Modal show={ShowPhotoModal} backdrop="static" scrollable keyboard={false} onHide={() => setShowPhotoModal(false)} size="xl"  >
                <Modal.Header >
                    <Modal.Title className='fs-5'><b>تصاویر {Title}    </b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <rsuite.Grid fluid>
                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <rsuite.Row>
                                    <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <rsuite.Row>

                                        </rsuite.Row>
                                        <BiIcon.BiSolidStar className={PhotoURLName == "" ? 'text-danger' : 'hide'} />  <label>عنوان تصویر</label>
                                        <rsuite.Input value={PhotoURLName} onChange={(e) => setPhotoURLName(e)} />
                                    </rsuite.Col>
                                    <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <rsuite.Row>

                                        </rsuite.Row>
                                        <BiIcon.BiSolidStar className={Order == "" ? 'text-danger' : 'hide'} />  <label>ترتیب نمایش</label>
                                        <rsuite.Input value={Order} onChange={(e) => setOrder(e)} />
                                    </rsuite.Col>
                                    <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <rsuite.Checkbox onChange={(e, checked) => setIsMain(checked)} checked={IsMain} value={IsMain} /> &nbsp; تصویر اصلی می باشد

                                    </rsuite.Col>
                                </rsuite.Row>

                            </rsuite.Col>

                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='text-center'>

                                <label htmlFor="upload-button">
                                    {Image.preview ? (
                                        <div className='ProductPic bg-white shadow-sm rounded d-flex align-items-center justify-content-center '>

                                            <img src={Image.preview} alt="dummy" className='ProductPic' />
                                        </div>
                                    ) : (

                                        <div className='ProductPic bg-gray rounded shadow-sm  align-items-center justify-content-center pt-5'>
                                            <BiIcon.BiCamera className='fs-3'></BiIcon.BiCamera>
                                            <br />
                                            <div className="text-center ّ Cursor">  به منظور انتخاب تصویر (.jpg) کلیک کنید</div>
                                            <div className="text-center ّ Cursor">  180*240</div>
                                        </div>
                                    )}
                                </label>
                                <input
                                    type="file"
                                    id="upload-button"
                                    style={{ display: "none" }}
                                    onChange={ImageChange}
                                    accept="image/jpg"
                                />


                            </rsuite.Col>



                        </rsuite.Row>

                        <rsuite.Row className='mt-3'>
                            {PhotoList.map((photo) =>
                                <rsuite.Col xxl={6} xl={6} lg={8} md={12} sm={12} xs={24} className='text-center'>

                                    <rsuite.Panel shaded bordered bodyFill className={photo.IsMain == 1 ? "border-success" : ""} style={{ display: 'inline-block', width: 240 }}>
                                        <img src="https://via.placeholder.com/240x180" height="180" />
                                        <rsuite.Panel className='text-start'>

                                            <rsuite.Button size='xs' color="red" appearance="primary" onClick={() => DeletePhoto(photo.Id)}>
                                                حذف
                                            </rsuite.Button>
                                        </rsuite.Panel>
                                    </rsuite.Panel>


                                </rsuite.Col>
                            )}


                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={SavePhoto}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setShowPhotoModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>



            <Delete ref={DeleteRef} onSubmit={Search} />
        </Layout >


    )
}

export default ProductIndex;